import Loader from "../../../assets/icons/loader.svg";

export default {
  name: "Loading",
  props: {
    loading: Boolean,
    text: String,
    freezeBody: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Loader
  },
  mounted() {
    this.loading ? this.show() : this.hide();
  },
  methods: {
    show() {
      if (this.freezeBody) {
        document.querySelectorAll("body").forEach(item => {
          item.style.position = "fixed";
          item.style.maxWidth = "1920px";
        });
      }
    },
    close() {
      document.querySelectorAll("body").forEach(item => {
        item.removeAttribute("style");
      });
    }
  },
  watch: {
    loading: function(show) {
      show ? this.show() : this.close();
    }
  },
  template: `<div class="argus__loading" v-if="loading"><loader class="argus__loader"></loader><span>{{ text }}</span></div>`
};
